module.exports = __webpack_public_path__ + "img/hot2x.png?41a89185757b26b82cfc48b2a7b0f63d";